define(function (require) {
    "use strict";
    var _ = require("underscore");

    var DateUtility = (function () {

        var pad = function(number, length) {

            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        };

        return {

            DAY_IN_MILLIS: 24*60*60*1000,

            /**
             * * @param str "Y_M_D H-M-S" - single letter is conceptual only
             * _ is a separator for date can be "-" or "/" or ":"
             * - is a separator for time can be "-" or "/" or ":"
             * @returns {Date}
             */
            strToDateObj: function (str, options) {
                var retDateObj = {
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    milliseconds: 0
                };

                var date = str.split(" ")[0];

                var dateSep = date.indexOf("-")>-1 ? "-" :
                    date.indexOf("/")>-1 ? "/" : ":";

                retDateObj.year = parseInt(date.split(dateSep)[0], 10);
                retDateObj.month = parseInt(date.split(dateSep)[1], 10) - 1;
                retDateObj.day = parseInt(date.split(dateSep)[2], 10);

                if (str.split(" ").length > 1) {
                    var time = str.split(" ")[1];

                    var timeSep = time.indexOf("-")>-1 ? "-" :
                        time.indexOf("/")>-1 ? "/" : ":";

                    retDateObj.hours = parseInt(time.split(timeSep)[0], 10);
                    retDateObj.minutes = parseInt(time.split(timeSep)[1], 10);
                    retDateObj.seconds = parseInt(time.split(timeSep)[2], 10);
                    retDateObj.milliseconds = 0;
                }

                var retDate = new Date(retDateObj.year, retDateObj.month, retDateObj.day, retDateObj.hours, retDateObj.minutes, retDateObj.seconds, retDateObj.milliseconds);

                return retDate;
            },
            /**
             * Notice!!! the result is inclusive at one end and exclusive at the other meaning:
             * for an inclusive result add 1
             * for an exclusive result subtract 1
             * @param date1
             * @param date2
             * @returns {number}
             */
            getDaysDiff: function (date1, date2) {
                var ms = date1.getTime() - date2.getTime(); // miliseconds
                return ms / (24*60*60*1000);

            },
            /**
             *
             * @param string date1
             * @param string date2
             * @returns {number}
             */
            getDaysStrDiff: function (date1, date2) {
                return this.getDaysDiff(this.strToDateObj(date1), this.strToDateObj(date2));
            },

            getMaxStrDate : function(date1, date2){
                return this.getDaysStrDiff(date1, date2) >= 0 ? date1 :  date2;
            },

            getMinStrDate : function(date1, date2){
                return this.getDaysStrDiff(date1, date2) >= 0 ? date2 : date1;
            },


            /**
             *
             * @param date
             * @param clearTime boolean, optional, reset time to 00:00:00.
             * @returns str "Y_M_D H-M-S" - single letter is conceptual only
             */
            date2Str:function(date, clearTime){

                var str = '', hour="00",min ="00",sec="00", dateSeparator= "-", timeSeparator=":";

                if(_.isDate(date)){

                    var day = pad(date.getDate(),2);
                    var month = pad(date.getMonth()+1,2);
                    var year = date.getFullYear();

                    if(!clearTime){
                        hour = pad(date.getHours(), 2);
                        min = pad(date.getMinutes(),2);
                        sec = pad(date.getSeconds(),2);
                    }

                    str = year + dateSeparator + month + dateSeparator + day + ' ' + hour + timeSeparator + min + timeSeparator + sec ;
                }
                return str;
            },
            /**
             * Returns a YYYY-MM-dd date string
             * @param date
             * @returns {string}
             */
            date2StrYYYYMMdd: function(date) {
                var day = date.getDate();
                var month = date.getMonth() + 1; // Months are zero based
                var year = date.getFullYear();

                if(day < 10) {
                    day = "0" + String(day);
                }

                if(month < 10) {
                    month = "0" + String(month);
                }

                return year + "-" + month + "-" + day;
            },
            timeObjectToSte: function (timeObj) {
                var separator = "-";
                var day = timeObj.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                var month = timeObj.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                return timeObj.getFullYear() + separator + month + separator + day;
            },
            /**
             * Returns a dd-MM-YYY date string
             * @param date
             * @returns {string}
             */
            date2StrddMMYYYY: function(date) {

                var day = date.getDate();
                var month = date.getMonth() + 1; // Months are zero based
                var year = date.getFullYear();

                if(day < 10) {
                    day = "0" + day;
                }

                if(month < 10) {
                    month = "0" + month;
                }

                return "" + day + month + year;
            },
            /**
             * Returns whether the date parameter is less than the current date
             * @param date The date to check
             * @return {Boolean}
             */
            isExpired: function(date){
                var now = new Date().getTime();
                return (date < now);
            },

            getTodayStr: function() {
                var today = new Date();
                return this.date2Str(today, true);
            },

            getTomorrowStr: function() {
                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                return this.date2Str(tomorrow, true);
            }
        };
    })();
    return DateUtility;

});
